export default (state ={grid: {}}, action) => {
	switch (action.type) {
		case 'FETCH_COMMS_VIEWER':
			return action.payload;
		default:
			return state;
	}
};
